import { useForm, Form } from "em-form";
import Button from "components/Button";
import eventStop from "components/ReactUtils/eventStop";
import KaInput from "components/Form/KaInput";
import React, { useState, Component } from "react";
import styled, { css } from "react-emotion";
import theme from "components/theme";

import api from "../api3";
import HeaderWithTopLine from "./HeaderWithTopLine";
import useWindowSize from "../hooks/useWindowSize";

function NewsletterForm(props) {
  const form = useForm({
    data: { email: "" },
    constraints: {
      email: {
        presence: { message: "Bitte gib deine E-Mail Adresse an." },
        email: { message: "Bitte gib eine gültige E-Mail Adresse an." },
      },
    },
  });
  const [isSubmitted, setSubmitted] = useState(false);
  const windowSize = useWindowSize();

  const onSubmit = async e => {
    eventStop(e);

    if (!form.isValid) return;

    await api.post("newsletterEmailSave", { email: form.data.email });

    setSubmitted(true);

    window.gaTest("send", {
      hitType: "event",
      eventCategory: "Button",
      eventAction: "Signup",
      eventLabel: "NL signup",
    });
  };

  return (
    <div className={props.className}>
      {!isSubmitted && (
        <Form {...form} onSubmit={onSubmit} name="emailLightBox">
          <div className="text-center">
            {windowSize.isMobile && (
              <div>
                <KaInput
                  label="E-mail hier eingeben..."
                  type="email"
                  name="email"
                  validateOnBlur={false}
                  className={"input"}
                />
                <Button type="submit" motif="gray" className={"submitButton"}>
                  ABSENDEN
                </Button>
              </div>
            )}
            {!windowSize.isMobile && (
              <KaInput
                label="E-mail hier eingeben..."
                type="email"
                name="email"
                size="lg"
                inputGroup
                validateOnBlur={false}
                mobileGroup
                inputGroupAdd={
                  <span className="input-group-btn">
                    <Button inGroup type="submit" motif="gray">
                      ABSENDEN
                    </Button>
                  </span>
                }
              />
            )}
          </div>
        </Form>
      )}

      {isSubmitted && (
        <div id="success" className={"successBox"}>
          <h4 className="text-center">Danke für deine Anmeldung!</h4>
        </div>
      )}
    </div>
  );
}

NewsletterForm = styled(NewsletterForm)`
  margin: 30px auto 30px auto;
  max-width: 550px;

  input[type="email"] {
    color: ${theme.colors.grayDark};
    border-color: ${theme.colors.primaryInverse} !important;
    background-color: ${theme.colors.primaryInverse};
    box-shadow: none;
  }

  button,
  html[data-touch="no-touch"] button:hover {
    border-color: #fff !important;
  }

  .submitButton {
    width: 100%;
  }

  .input {
    .form-control {
      height: 45px;
    }
  }

  .successBox {
    color: ${theme.colors.black};
  }

  .bg {
    border-color: ${theme.colors.primaryInverse} !important;
  }

  label {
    color: ${theme.colors.grayDark} !important;
  }

  input:placeholder {
    color: ${theme.colors.grayDark};
  }
`;

class FooterNewsletter extends Component {
  render() {
    const { styles } = this;

    return (
      <div className={styles.root}>
        <HeaderWithTopLine title="NEWSLETTER" />
        <div className={styles.subHeader}>
          Hinterlasse uns deine E-mail Adresse und erhalte Tipps und Inspirationen für deine neue Küche!
        </div>
        <NewsletterForm />
      </div>
    );
  }

  styles = {
    root: css`
      min-width: 370px;
      ${theme.media.xsMax} {
        min-width: 100%;
        width: 100%;
        padding-bottom: 11.5px;
      }
      text-align: center;
    `,
    subHeader: css`
      font-size: 14px;
      ${theme.fonts.bold};
      color: ${theme.colors.grayDark};
    `,
    headerLine: css`
      margin-top: 5px;
      margin: 5px auto 15px;
      width: 50px;
      height: 2px;
      border: solid 2px ${theme.colors.primary};
    `,
  };
}

export default FooterNewsletter;
